import CxSurveyPanel from "./CxSurveyPanel";
import SupervisorEvalPanel from "./SupervisorEvalPanel";
import { useState } from "react";
import BreadCrumb from "../Controls/BreadCrumb";
import NoticeListItem from "../ListItems/NoticeListItem";
import NoticeDetailsModal from "../Modals/NoticeDetailsModal";
import UserData from "../Controls/UserData";
import { Link } from "react-router-dom";
import EmployerListItem from "../ListItems/EmployerListItem";

export default function Dashboard() {
  const [userData] = useState(UserData.UserData());
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [pendingAgreements] = useState(
    (userData.agreements || []).filter((a) => {
      return !a.DateAccepted;
    })
  );
  const [myEmployers] = useState(
    (userData.employers || []).filter((e) => {
      return e.EmployerAdminRoles && e.EmployerAdminRoles.length > 0;
    }) || []
  );
  return (
    <div className="pagebody">
      <BreadCrumb />
      <div className="tabbody">
        <h2>Dashboard</h2>
        <CxSurveyPanel />
        <SupervisorEvalPanel />
        {pendingAgreements && pendingAgreements.length > 0 ? (
          <div className="tabsection">
            <div className="listTitle">
              <span>Pending Agreements</span>
            </div>
            <ol>
              {pendingAgreements.map((a, index) => {
                return (
                  <li key={a.AgreementID || `agreement-${index}`}>
                    <Link to={"/agreementSignature/" + a.AgreementID}>{a.Name}</Link>
                  </li>
                );
              })}
            </ol>
          </div>
        ) : (
          ""
        )}

        <div className="tabsection">
          <div className="listTitle">
            <span>Your companies</span>
          </div>
          <ol>
            {myEmployers.map((emp) => {
              return <EmployerListItem key={emp.ID} employer={emp} />;
            })}
          </ol>
        </div>

        <div className="tabsection">
          <div className="listTitle">
            <span>Notices ({(userData.personNotices || {}).length})</span>
          </div>
          <ol>
            {(userData.personNotices || []).map((notice) => (
              <NoticeListItem
                key={notice.ID}
                notice={notice}
                onSelect={setSelectedNotice}
              />
            ))}
          </ol>
        </div>
      </div>
      {selectedNotice ? (
        <NoticeDetailsModal
          notice={selectedNotice}
          onClose={() => setSelectedNotice(null)}
        />
      ) : null}
    </div>
  );
}
